import HeaderV2 from "./Header";
import type { HeaderProps } from "./Header";

export { HeaderV2 };
export type { HeaderProps };
export default HeaderV2;
